// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

import { tns } from "tiny-slider/src/tiny-slider";

const fragments = {
	BUTTON_PREV: '[data-controls="prev"]',
	BUTTON_NEXT: '[data-controls="next"]',
	SUB_SLIDER: '[data-fragment="SubScrollTinySlider.subSlider"]',
};

let tnsSlider = [];
var slider = null;
var sliderWrapBgr;
var subSliderIter = 0;

export default class IconTinySlider extends WebComponent {
	constructor(props) {
		super(props);
		const {
		} = props;
		this.state = {
		};
	}

	fixSliderFunction = (info) => {
		info.event.preventDefault();
		info.event.stopPropagation();
	}

	didMount() {
		this.subSliderElement = this.element.querySelectorAll(fragments.SUB_SLIDER);
		var _self = this;
		for(subSliderIter = 0; subSliderIter < this.subSliderElement.length; subSliderIter++) {
			tnsSlider.push(tns({
				container: this.subSliderElement[subSliderIter].querySelector('.sub-slider__list'),
				controlsContainer: this.subSliderElement[subSliderIter].querySelector('.sub-slider__controls'),
				mode: 'gallery',
				animateIn: null,
				speed: 500,
				loop: false,
				items: 1,
				navContainer: this.subSliderElement[subSliderIter].querySelector('.sub-slider__dots'),
				navAsThumbnails: true,
				nav: true,
				slideBy: 'page',
				nested: 'inner',
				mouseDrag: true
			}));
		   tnsSlider[subSliderIter].events.on('dragStart', this.fixSliderFunction);
		   tnsSlider[subSliderIter].events.on('touchStart', this.fixSliderFunction);
		   tnsSlider[subSliderIter].events.on('indexChanged', function(e){
			   if(window.innerWidth >= 1024){
				   _self.handleUpdateGallerySlidePositions(slider.getInfo().indexCached);
			   }
		   });
		}

		slider = tns({
			container: '.slider__list',
			controlsContainer: '.slider__controls',
			mode: 'gallery',
			animateIn: null,
			speed: 500,
			items: 1,
			loop: false,
			nav: true,
			navContainer: '.slider-menu',
			slideBy: 'page',
			nested: 'outer',
			mouseDrag: true
		});

		window.addEventListener("resize", function(){
			_self.setSlideBackgroundHeight(0);
		});
		sliderWrapBgr = this.element.querySelector('.slider__wrap-bgr');
		this.setSlideBackgroundHeight(0);

		setTimeout(function(){
			slider.getInfo().slideItems[0].querySelector('.sub-slider__wrap').classList.remove('sub-slider__wrap--hidden');
		},300);

		slider.events.on('dragStart', this.fixSliderFunction);
		slider.events.on('touchStart', this.fixSliderFunction);
		slider.events.on('indexChanged', function(){
			_self.handleUpdateGallerySlidePositions(null);
		});

	}

	handleUpdateGallerySlidePositions = (subSliderId) => {
		var _self = this;
		var info =  slider.getInfo(), indexPrev = info.indexCached, indexCurrent = info.index;
		if(subSliderId != null) {
			info = tnsSlider[subSliderId].getInfo(), indexPrev = info.indexCached, indexCurrent = info.index;
		}
		window.addEventListener("resize", function(){
			_self.setSlideBackgroundHeight(indexCurrent);
		});
		this.setSlideBackgroundHeight(indexCurrent);

		if(subSliderId == null) {
			var subSliderWrapPrev = info.slideItems[indexPrev].querySelector('.sub-slider__wrap');
			var subSliderWrapCurrent = info.slideItems[indexCurrent].querySelector('.sub-slider__wrap');
			if(subSliderWrapPrev !== null) {
				subSliderWrapPrev.classList.add('sub-slider__wrap--hidden');
			}
			if(subSliderWrapCurrent !== null) {
				subSliderWrapCurrent.classList.remove('sub-slider__wrap--hidden');
			}
		}

		// update style based on index
		info.slideItems[indexCurrent].classList.remove('slideInRight');
		info.slideItems[indexCurrent].classList.remove('slideInLeft');
		info.slideItems[indexPrev].classList.remove('slideInRight');
		info.slideItems[indexPrev].classList.remove('slideInLeft');

		if(indexPrev < indexCurrent) {
			info.slideItems[indexCurrent].classList.add('slideInRight');
		}
		if(indexPrev > indexCurrent) {
			info.slideItems[indexCurrent].classList.add('slideInLeft');
		}
		info.slideItems[indexPrev].classList.remove('tns-slide-active');
		info.slideItems[indexCurrent].classList.add('tns-slide-active');
	}


	setSlideBackgroundHeight = (i) => {
		var info = slider.getInfo();
		var sliderMenuHeight = this.element.querySelector('.slider-menu').offsetHeight;
		var slideItemHeight = info.slideItems[i].offsetHeight;
		var subSliderWrap =  info.slideItems[i].querySelector('.sub-slider__wrap');
		var subSliderWrapHeight = 0;
		if(subSliderWrap !== null){
			subSliderWrapHeight = subSliderWrap.offsetHeight;
		}
		var subSliderOffset = 100;
		if(window.innerWidth >= 1024){
			subSliderOffset = 150;
		}
		var bgrHeight = slideItemHeight + sliderMenuHeight - (subSliderWrapHeight - subSliderOffset);
		sliderWrapBgr.style.height = bgrHeight + 'px';
	}
}



// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/TinySliders/IconTinySlider.js